type TelemetryRenderErrorProps = {
  shouldThrow: boolean;
};

const TelemetryRenderError = ({ shouldThrow }: TelemetryRenderErrorProps) => {
  if (shouldThrow) {
    throw new Error("Telemetry test render error");
  }

  return null;
};

export default TelemetryRenderError;
